/*** IMPORTS FROM imports-loader ***/
var define = false;

export default {
	"INID.survey.moreThanNeeded" : "More than perscribed",
	"INID.survey.asNeeded" : "As perscribed",
	"INID.survey.notUsed" : "Did not used it",
	"INID.survey.feltSick" : "Felt very sick",
	"INID.survey.hardlyBearable" : "It was hardly bearable",
	"INID.survey.smallProblem" : "Only had small problem",
	"INID.survey.hadNoProblem" : "Had no problem at all",
	"INID.unit.lpm" : "Liter / minute",
	"INID.unit.mlpm" : "Milliliter / minute",
	"INID.unit.cm" : "cm",
	"INID.unit.kg" : "kg",
	"INID.survey.causePhysical" : "Physical exercise, running, laughing, crying",
	"INID.survey.causeSmog" : "Smog",
	"INID.survey.causeWind" : "Wind",
	"INID.survey.causeEmotion" : "Emotions",
	"INID.survey.causeUnknown" : "I don\'t know",
	"INID.survey.asthma" : "Asthma",
	"INID.survey.copd" : "COPD",
	"INID.survey.allergy" : "Allergy",

	"INID.survey.lastHour": "In the last hour",
	"INID.survey.forenoon": "At morning",
	"INID.survey.night": "At night",
	"INID.survey.yesterDayEvening": "Yesterday evening",
	"INID.survey.other": "Other time",

	"INID.survey.controlWorkoutNone": "Had no workout",
	"INID.survey.controlWorkoutWeeklyTwo": "2 hours a week",
	"INID.survey.controlWorkoutWeeklyFour": "4 hours a week",
	"INID.survey.controlWorkoutWeeklySix": "6 hours a week",
	"INID.survey.controlWorkoutWeeklyMore": "More than 8 hours a week",

	"INID.survey.generalControlAll": "Used as perscribed",
	"INID.survey.generalControlMostly": "Mostly as perscribed",
	"INID.survey.generalControlHalf": "Half of the perscribed dose",
	"INID.survey.generalControlRare": "Rarely used it",
	"INID.survey.generalControlNone": "Did not used it",

	// TODO: Translate ACT fields!

	"INID.ACTWork.0" : "Folyamatosan",
	"INID.ACTWork.1" : "Gyakran",
	"INID.ACTWork.2" : "Néha",
	"INID.ACTWork.3" : "Ritkán",
	"INID.ACTWork.4" : "Soha",

	"INID.ACTBreath.0" : "Naponta többször",
	"INID.ACTBreath.1" : "Naponta egyszer",
	"INID.ACTBreath.2" : "Heti 3-6 alkalommal",
	"INID.ACTBreath.3" : "Heti 1-2 alkalommal",
	"INID.ACTBreath.4" : "Egyszer sem",

	"INID.ACTSleep.0": "Hetente legalább 4 alkalommal",
	"INID.ACTSleep.1": "Hetente 2-3 éjszaka",
	"INID.ACTSleep.2": "Hetente 1 alkalommal",
	"INID.ACTSleep.3": "Heti 1-2 alkalommal",
	"INID.ACTSleep.4": "Soha",

	"INID.ACTMedication.0": "Naponta legalább 3 alkalommal",
	"INID.ACTMedication.1": "Napi 1-2 alkalommal",
	"INID.ACTMedication.2": "Heti 2-3 alkalommal",
	"INID.ACTMedication.3": "Heti 1 alkalommal vagy ritkábban",
	"INID.ACTMedication.4": "Nem kellett használnom",

	"INID.ACTSubjective.0": "Egyáltalán nem kontrollált",
	"INID.ACTSubjective.1": "Rosszul kontrollált",
	"INID.ACTSubjective.2": "Részben kontrollált",
	"INID.ACTSubjective.3": "Jól kontrollált",
	"INID.ACTSubjective.4": "Tökéletesen kontrollált",

	"INID.ACTSummary.problem": "Not well controlled",
	"INID.ACTSummary.ok": "Well controller"
}



// WEBPACK FOOTER //
// ./src/strings/generated_en.js